module.exports = "/_next/static/files/2a5b0c023966d2d22c7166786a958a44.svg";